import React from 'react';

function SideBetsWrapper({ children }) {
  return <div className='tb-sidebets-wrapper'>{children}</div>;
}
export default SideBetsWrapper;
